import React from "react";
import { useTranslation } from "react-i18next";
import { AccessContext, Type } from "../../index";

export const NotApplicableRenderer = () => {
  const i18n = useTranslation();
  return <span>{i18n.t("lego:notApplicable", "NA")}</span>;
};

export const NotApplicable = (
  type: Type,
  condition: (ctx: AccessContext) => boolean
) => {
  return (ctx: AccessContext) =>
    condition(ctx)
      ? new Type({
          Component: type.Component,
          PresentationComponent: NotApplicableRenderer,
          props: type.props,
          validators: type.validators
        })
      : new Type({
          Component: type.Component,
          PresentationComponent: type.PresentationComponent,
          props: type.props,
          validators: type.validators
        });
};
